<template>
  <header
    id="js-the-header"
    class="the-header"
  >
    <navigation-contacts v-bind:contacts="contacts"></navigation-contacts>
    <navigation-main v-bind:navigation="navigation"></navigation-main>
  </header>
</template>

<script>
import NavigationContacts from './the-header/NavigationContacts'
import NavigationMain from './the-header/NavigationMain'

export default {
  name: 'TheHeader',
  components: {NavigationContacts, NavigationMain},
  data: function () {
    return {
      navigation: [],
      contacts: {}
    }
  },
  mounted () {
    this.getNavigation()
  },
  methods: {
    getNavigation: function () {
      this.$http
        .get(`${process.env.API_HOST}/api/v1/site-structure/get-menu`)
        .then(response => { this.initHeaderData(response.body) })
    },
    initHeaderData: function (navigation) {
      this.navigation = navigation

      const contactsIndex = this.navigation.findIndex(
        (element, index, array) => {
          return element.alias === 'contacts'
        })
      if (contactsIndex > -1) {
        this.contacts = Object.assign({}, this.navigation[contactsIndex])
        this.navigation[contactsIndex].short_name = 'Контакты'
      }
    }
  }
}
</script>

<style lang="scss">
  .the-header {
    font-family: "Gotham Pro Regular", $font-stack;
    background-color: $default-background-color;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 100;

    * { box-sizing: border-box; }
    a { text-decoration: none; }
    li {
      display: inline-block;
      margin: 0;
    }
    @media only print {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TheHeader.vue